<template>
  <div class="findlaw_hfrmzx">
    <div class="t1_fluid w_100 text_center">
      <div class="t1">
        <div>
          <sec-title
            Text="合肥热门咨询"
            desc-text="在线服务，快速回复"
          ></sec-title>
        </div>
        <div class="cont1 between">
          <div class="cont1_l">
            <div class="cont1_title between">
              <sub-title text="热门咨询" />
              <div>更多></div>
            </div>
            <div class="problem_list between wrap">
              <div class="card_item" v-for="(item, index) in 6" :key="index">
                <div class="w flex_start">
                  <img src="~assets/question/w.png" />
                  {{
                    `企业要求强制接种新冠疫苗，否则当月工资清零，否则当月工资清零，这种做法合理吗`
                      | toEllipsisFilter(32)
                  }}
                </div>
                <div class="d flex_start">
                  <img src="~assets/question/d.png" />

                  {{ `不合理` | toEllipsisFilter(15) }}
                </div>
                <div class="t between">
                  <div>
                    <span class="tag">劳动纠纷</span>
                    <span class="tag">合肥</span>
                    <span class="tag">2021-03-27</span>
                  </div>
                  <div class="text_hover_shou"><span>2</span>位律师回复 >></div>
                </div>
              </div>
            </div>

            <!-- <div class="cont1_bt">
              <sub-title text="为什么要聘请律师？" />
              <div class="tg1">
                <span class="tagc1">解决法律纠纷</span>
                <span class="tagc1">降低经济损失</span>
                <span class="tagc1">保障合法权益</span>
              </div>
            </div> -->
          </div>
          <div class="cont1_r">
            <div class="rtop">
              <div class="rtop1">在线服务状态</div>
              
              <div class="rtop3">
				  <em>今日已服务：</em>
                <span>1</span>
                <span>2</span>
                <span>3</span>
                <span>4</span>
                人
              </div>
            </div>
            <div class="rmiddle">
              <div class="rmt1">
                <sub-title text="合肥律师回复动态" />
              </div>
              <home-timeline class="timeline" :fonum="3" :spl="12" />
            </div>

<!--            <ul class="advantage">
              <li v-for="(item, index) in 4" :key="index">
                为什么要聘请律师？
              </li>
            </ul> -->
          </div>
        </div>
      </div>
    </div>
    <div class="t2_fluid">
      <div class="t2">
        <div class="t2_title flex_start">
          <div :class="{ tag_act: tagstatus == 1 }" @click="tag_cli(1)">
            合肥最新咨询
          </div>
          <div :class="{ tag_act: tagstatus == 2 }" @click="tag_cli(2)">
            最新解答
          </div>
        </div>
        <div class="tag_swiper">
          <el-carousel
            height="270px"
            :interval="5000"
            direction="vertical"
            ref="tag_swiper"
            trigger="click"
            @mouseenter.native="autoplayHandler"
          >
            <el-carousel-item v-for="item in 3" :key="item">
              <ul class="tag_swiper_item">
                <li class="flex_start" v-for="item in 4" :key="item">
                  <div class="time">30分钟前</div>
                  <div class="xian"></div>
                  <div class="yuan"></div>
                  <div>
                    父母离异，抚养权是父亲，代养权是妈妈，弟弟一直是妈妈再带，现在因为矛盾现在因为矛盾现在因为矛盾现在因为矛盾现...
                  </div>
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>
        
		<div class="fea_service between">
          <div class="l1 flex between">
            <!-- <img src="~assets/findlawyers/tl.png" alt="" /> -->
			
			<div class="l1item"@mouseenter="toshowbtn(index)" @mouseleave="hidebtn" v-for="(item,index) in 3">
				<div class="l1inner">
					<img src="../../../assets/contmodeldet/law_sample.png" >
					
				</div>
				<div class="innertext flex-col" >
					<span class="FontSize18">徐子成律师<span class="FontSize12">主办律师</span></span>
					<span class="FontSize14">律所：安徽鼎力律师事务所</span>
					<span class="FontSize18">152-5555-6000</span>
					<div class="zixun" v-if="showbtn == index">
						咨询我
					</div>
				</div>
			</div>
          </div>
          <div class="c1 between wrap">
			  <subTitle text="四大特色服务" />
            <div class="thediv flex_start borderbottom borderright">
              <div><img src="~assets/findlawyers/zixun.png" alt="" /></div>
              <div>
                <div class="xt">在线咨询</div>
                <div class="xd">一对一咨询在线律师， 回复快速高效不用等</div>
              </div>
            </div>

            <div class="thediv flex_start borderbottom">
              <div><img src="~assets/findlawyers/guhua.png" alt="" /></div>
              <div>
                <div class="xt">电话咨询</div>
                <div class="xd">案情紧急，通过电话直接沟 通效率更高</div>
              </div>
            </div>

            <div class="thediv flex_start borderright">
              <div><img src="~assets/findlawyers/xinxi.png" alt="" /></div>
              <div>
                <div class="xt">文字咨询</div>
                <div class="xd">通过文字形式提交，可 收到多个律师回复</div>
              </div>
            </div>

            <div class="thediv flex_start">
              <div><img src="~assets/findlawyers/tuwen.png" alt="" /></div>
              <div>
                <div class="xt">图文咨询</div>
                <div class="xd">图文并茂的表达问题，有助 于律师分析案情</div>
              </div>
            </div>
          </div>
          <lay-item-win class="r1" />
        </div>
		
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import subTitle from "views/home/components/subTitle";
import homeTimeline from "views/home/components/homeTimeline/homeTimeline";
import layItemWin from "views/home/components/layItemWin2";
export default {
  components: {
    secTitle,
    subTitle,
    layItemWin,
    homeTimeline,
  },
  data: () => ({
    tagstatus: 1,
	showbtn:Infinity
  }),
  methods: {
    autoplayHandler() {
      //取消轮播悬浮暂停
      this.$refs.tag_swiper.handleMouseEnter = () => {};
    },
    tag_cli(index) {
      this.tagstatus = index;
    },
	toshowbtn(index){
		this.showbtn = index
	},
	hidebtn(){
		this.showbtn = Infinity
	}
  },
};
</script>

<style lang="scss" scope>
.findlaw_hfrmzx {
  .t1_fluid {
    background-color: #f8f8f8;
    .t1 {
      width: 1200px;
      margin: 0 auto;
      padding: 50px 0;
      .cont1 {
        .cont1_l {
          width: 790px;
          align-items: start;

          .cont1_title {
            box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
            width: 790px;
            height: 57px;
            color: #666;
            background-color: #fff;
            padding: 19px 28px;
          }
          .problem_list {
            .card_item {
              width: 384px;
              height: 218px;
              text-align: left;
              background: #ffffff;
              padding: 28px;
              margin-top: 25px;
              box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
              .w,
              .d {
                align-items: start;
                img {
                  width: 32px;
                  height: 32px;
                  margin-right: 15px;
                }
              }
              .d {
                margin-top: 15px;
                color: #666;
              }
              .t {
                font-size: 12px;
                margin-top: 40px;
                color: #999;
                .tag {
                  background-color: #f8f8f8;
                  border-radius: 2px;
                  padding: 3px 7px;
                  margin-right: 8px;
                }
              }
            }
          }
          .cont1_bt {
            padding: 30px 28px;
            margin-top: 30px;
            background: #ffffff;
            box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
            .tg1 {
              margin-top: 30px;
              text-align: left;
              .tagc1 {
                padding: 3px 7px;
                border: 1px solid rgb(192, 192, 192);
                color: #777;
                margin-right: 10px;
                border-radius: 5px;
              }
            }
          }
        }
        .cont1_r {
          width: 380px;
          height: 600px;
          align-self: start;
          .rtop {
            width: 380px;
            height: 260px;
            text-align: left;
            padding: 40px 43px 0;
            color: #666;
            background: url(../../../assets/findlawyers/bg5.png) center/cover;
            .rtop1 {
              text-align: center;
              font-size: 24px;
              color: #333333;
            }
            .rtop2 {
              margin-top: 30px;
            }
            .rtop3 {
              margin-top: 27px;
			  em{
				  font-style: normal;
			  }
              span {
                padding: 15px 8px;
                margin-right: 4px;
                color: #fff;
                background: #0465ea;
              }
            }
          }
          .rmiddle {
            margin-top: 20px;
            .rmt1 {
              margin-left: 23px;
			  
            }
            .timeline {
              margin-top: 30px;
              background-color: #fff;
              width: 100%;
              padding: 20px 15px;
              .lv-timeline-item:last-child {
                .lv-timeline-item__tail {
                  height: 80%;
                }
              }
            }
          }
          .advantage {
            width: 100%;
            background-color: #fff;

            margin-top: 30px;
            overflow: hidden;
            text-align: left;
            font-size: 14px;
            color: #999;
            box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
            border-radius: 2px;
            padding: 10px 30px;
            li {
              list-style: disc;
              line-height: 28px;
              &:hover {
                color: #0465ea;
              }
            }
          }
        }
      }
    }
  }

  .t2_fluid {
    background-color: #fff;
    .t2 {
      width: 1200px;
      margin: 0 auto;
      padding: 50px 0;
      .t2_title {
        margin-bottom: 42px;
        font-size: 20px;
        > div {
          cursor: pointer;
          margin-right: 42px;
          position: relative;
        }
        .tag_act {
          &::after {
            content: "";
            width: 80%;
            height: 3px;
            position: absolute;
            bottom: -15px;
            left: 50%;
            transform: translateX(-50%);
            background-color: #0465ea;
          }
        }
      }
      .tag_swiper {
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
        .el-carousel__indicators--vertical {
          right: 16px;
        }
        .el-carousel__button {
          background-color: #cdcdcd;
          width: 4px;
        }
        .is-active {
          .el-carousel__button {
            background-color: #0465ea;
          }
        }
        .tag_swiper_item {
          padding: 30px 40px;
          border-radius: 2px;
          li {
            position: relative;
            margin-bottom: 40px;
            .time {
              color: #333333;
              opacity: 0.6;
              margin-right: 39px;
            }
            .xian {
              position: absolute;
              width: 1px;
              height: 39px;
              left: 80px;
              top: 22px;
              background: #e6e6e6;
            }
            .yuan {
              position: absolute;
              left: 77px;
              width: 6px;
              height: 6px;
              background: #0465ea;
              border-radius: 50%;
            }
            &:last-child {
              margin-bottom: 0;
              .xian {
                display: none;
              }
            }
          }
        }
      }
      .fea_service {
        margin-top: 30px;
        .l1 {
          width:780px ;
          height: 333px;
          border-radius: 2px;
          padding-left: 20px;
		  
         .l1item{
			 position: relative;
			 width: 247px;
			 height: 100%;
			 .l1inner{
			 			  width: 100%;
			 			  height: 276px;
						  img{
							  width: 100%;
						  }
			 }
			 .innertext{
			 			  position: absolute;
			 			  bottom: -40px;
						  margin-left: -117px;
						  padding: 18px 14px;
						  text-align: left;
						  left: 50%;
			 			  width: 234px;
			 			  height: 110px;
			 			  background: #FFFFFF;
			 			  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
			 			  border-radius: 10px;
						  .zixun{
							  position: absolute;
							  top: -14px;
							  left: 50%;
							  margin-left: -54px;
							  width: 108px;
							  height: 28px;
							  background: #0465EA;
							  box-shadow: 0px 1px 10px 0px rgba(1, 67, 158, 0.42);
							  border-radius: 14px;
							  text-align: center;
							  color: #fff;
							  font-size: 16px;
						  }
			 }
		 }
        }
        .c1 {
         width: 384px;
         height: 398px;
          border: 1px solid #dbdbdb;
          padding: 20px;
          border-radius: 4px;
          .thediv {
            // padding-left: 20px;
            width: 100%;
            height: 85px;
          }
          img {
            width: 52px;
            height: 52px;
			margin-right: 13px;
          }
          .xt {
            color: #333333;
          }
          .xd {
            width: 100%;
            margin-top: 16px;
            font-size: 14px;
            color: #666666;
          }
        }
        .r1 {
          width: 260px;
          height: 340px;
        }
      }
    }
  }
}
</style>